module.exports = __webpack_public_path__ + "static/media/govno_rainbow.49746dc4.svg";